import { useState, useEffect, useCallback } from 'react';

export const useTranscription = () => {
  const [displayText, setDisplayText] = useState(''); // All confirmed text
  const [currentPartial, setCurrentPartial] = useState(''); // Current partial being typed
  const [isTyping, setIsTyping] = useState(false);
  const [finalText, setFinalText] = useState(''); // For other components

  // Simplified text processing
  const processTranscriptText = useCallback((text, isFinal = false) => {
    if (!text || typeof text !== 'string' || text === "[listening...]") {
      return;
    }
    
    const cleanText = text.trim();
    if (!cleanText || cleanText.length < 2) {
      return;
    }

    if (isFinal) {
      // Final text: add to confirmed display, partial text will be cleared
      setDisplayText(prev => prev ? prev + ' ' + cleanText : cleanText);
      setCurrentPartial('');
      setIsTyping(false);
    } else {
      // Partial text: show with typing effect
      setIsTyping(true);
      
      const words = cleanText.split(' ').filter(w => w.trim());
      let wordIndex = 0;
      
      setCurrentPartial('');
      
      const typeNext = () => {
        if (wordIndex < words.length) {
          setCurrentPartial(words.slice(0, wordIndex + 1).join(' '));
          wordIndex++;
          setTimeout(typeNext, 80 + Math.random() * 40);
        } else {
          setIsTyping(false);
        }
      };
      
      typeNext();
    }
  }, []);

  // Keep finalText synchronized with displayText for other components
  useEffect(() => {
    setFinalText(displayText);
  }, [displayText]);

  // Clear all text
  const clearTranscription = useCallback(() => {
    setDisplayText('');
    setCurrentPartial('');
    setIsTyping(false);
    setFinalText('');
  }, []);

  return {
    displayText,
    currentPartial,
    isTyping,
    finalText,
    processTranscriptText,
    clearTranscription
  };
};